import { Component, Input, OnChanges } from '@angular/core';

@Component({
  selector: 'iris-avatar',
  template: `
    <div [ngClass]="size">
      <img [ngClass]="size"
        *ngIf="src; else initials"
        [src]="src"
        [alt]="alt"
        [ngStyle]="imgStyles"
      />
      <ng-template #initials>
        <div [ngStyle]="nameStyles"
            class="initials"
            [ngClass]="colorCssClass">
          <span>{{ alt }}</span>
        </div>
      </ng-template>
    </div>
  `,
  styleUrls: ['./avatar.component.scss']
})
export class AvatarComponent implements OnChanges {
  @Input() src = '';
  @Input() name = '';
  @Input() backgroundType: 'solid' | 'subtle' = 'solid';
  @Input() size: 'small' | 'medium' | 'large' = 'medium'
  @Input() imgStyles: { [type: string]: string } = {};
  @Input() nameStyles: { [type: string]: string } = {};

  alt = '';
  bgColors = [
    'red', 'pink', 'purple', 'deep-purple', 'indigo', 'blue',
    'light-blue', 'cyan', 'teal', 'green', 'light-green',
    'lime', 'amber', 'orange', 'deep-orange',
  ];
  colorCssClass = '';

  constructor() {}

  ngOnChanges(): void {
    if (!this.src) {
      this.alt = this.createInitials(this.name);
      this.colorCssClass = `${this.backgroundType}-${this.getBackground(this.name)}`;
    }
  }

  createInitials(name: string): string {
    return name
      .trim()
      .split(' ')
      .slice(0, 3)
      .map(word => word[0])
      .join('');
  }

  getBackground(name: string): string {
    return this.bgColors[name.length % this.bgColors.length];
  }
}
